// Labels resource
const EVENT = {
    CLICK: 'click'
}
const EVENT_TYPE = {
    PAGE: 'page',
    INTERACTION: 'interaction'
}
  
const CATEGORY = category();

/**
 * Get the category
 * The category can be used in metrics
 * Usage: place the data-category attribute on the body element
 * @returns {string}
 */
function category() {
    const dataCategory = "data-category";
    const element = document.querySelector(`[${dataCategory}]`);
    if (element) {
        return element.dataset.category;
    }
    return `attribute ${dataCategory} missing`;
}

export { EVENT, EVENT_TYPE, CATEGORY }